import fetch from 'utils/fetch';
import { DomainObject, Params, Result } from 'types';
import { SortOrder } from 'enums';

export async function fetchList<TObject extends DomainObject>(
  url: string,
  defaultParams: Params = {}
): Promise<Result<TObject>> {
  const {
    sort = [{ field: 'name', order: SortOrder.ASC }],
    filters = [],
    size = 20,
    searchAfter,
  } = defaultParams;

  const params: Params = {
    sort,
    filters,
    size,
    searchAfter,
  };
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(params),
    headers: new Headers({ 'Content-Type': 'application/json' }),
  });

  const json = await response.json();

  return json;
}

export async function fetchDetail<T>(url: string) {
  const response = await fetch(url, {
    method: 'GET',
    headers: new Headers({ 'Content-Type': 'application/json' }),
  });

  const json: T = await response.json();

  return json;
}
